import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import { Observable, from } from 'rxjs';
import { SpxToasterAutoCloseSpeedEnum, spxToasterActions } from '@softpak/components/spx-toaster';
import { catchError, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';

import { ApiOrdMethod } from 'src/app/api/api-methods.ord';
import { OrdDeAllocateMultipleActions } from './ord-deallocate-multiple.actions';
import { OrdFiltersActions } from '../ord-filters/ord-filters.actions';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { Store } from '@ngrx/store';
import ordMultiAllocateReducer from '../ord-multi-allocate/ord-multi-allocate.reducer';

@Injectable()
export class OrdDeallocateMultipleEffects {
    // Injects
    private readonly store = inject(Store);
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);

    afterLoad: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdDeAllocateMultipleActions.load),
        withLatestFrom(this.store.select(ordMultiAllocateReducer.selectModeIsActive)),
        filter(([_, multiAllocateIsActive]) => !multiAllocateIsActive),
        mergeMap(([action]) => from(this.sharedGenericService.invoke(ApiOrdMethod.ordDeallocate))
            .pipe(
                mergeMap(result => {
                    const actionsToReturn: any[] = [
                        OrdDeAllocateMultipleActions.received({
                            result,
                        }),
                    ];

                    if (!action.skipRefresh) {
                        actionsToReturn.push(OrdFiltersActions.update({}));
                    }

                    return actionsToReturn;
                }),
                catchError((error) => {
                    console.error(error);
                    return [
                        OrdDeAllocateMultipleActions.error({
                            error,
                        }),
                        spxToasterActions.createError({
                            autoClose: error.autoclose ? 5000 : undefined,
                            messageText: `${error?.title ? `${error?.title}: ` : ``} ${error.message}`,
                        }),
                    ];
                })
            )))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdDeAllocateMultipleActions.error),
        mergeMap((action) => [
            spxToasterActions.createError({
                messageText: `Error in allocation`,
                autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
            }),
        ]))
    );
}
